// extracted by mini-css-extract-plugin
export default {"QuizPage":"quizFmtRearrangement_QuizPage__6mzQC","drop-zone-row":"quizFmtRearrangement_drop-zone-row__6XVCh","draggable-row":"quizFmtRearrangement_draggable-row__KGwK5"};